import nomes from './situacoes.nomes';

const TotaisComanda = {
  statusFinal: null,
  situacoes: [
    nomes.Agendado,
    nomes.AgendadoProfissional,
    nomes.AgendadoProfissionalPreferencial,
    nomes.Confirmado,
    nomes.Presente,
    nomes.Executado,
    nomes.Faltou,
    nomes.Bloqueio
  ],
  init(linhasAgenda){
    let idsComandas = this.getIdsComandas(linhasAgenda);
    let comandaStatus = this.getStatusComandas(idsComandas, linhasAgenda);
    this.statusFinal = this.getStatusComanda(comandaStatus);
  },

  getStatusFinal(){
    return this.statusFinal;
  },

  getStatusFinalPorTipo(tipo){
    let total = [];
    this.statusFinal.forEach((s) => {
      if(s.status == tipo){
        total.push(s);
      }
    });
    return total.length;
  },

  getIdsComandas(linhasAgenda)
  {
    let idsComanda = [];
    linhasAgenda.forEach((linha) => {
      let existe = idsComanda.length > 0 && idsComanda.includes(linha.idComanda);
      if (!existe) {
        idsComanda.push(linha.idComanda);
      }
    });
    return idsComanda;
  },

  getStatusComandas(idsComandas, linhasAgenda) {
    let comandaStatus = [];
    idsComandas.forEach((id) => {
      comandaStatus.push(
        {
          idComanda: id,
          status: this.getListaStatusPorComanda(id, linhasAgenda)
        }
      );
    });
    return comandaStatus;
  },

  getListaStatusPorComanda(idComanda, lista) {
    let status = [];
    lista.forEach((linha) => {
      if (linha.idComanda == idComanda) {
        status.push(linha.situacao);
      }
    });
    return status
  },

  getStatusComanda(comandaStatus) {
    let statusFinal = [];
    comandaStatus.forEach((reg) => {
      statusFinal.push({
        idComanda: reg.idComanda,
        status: this.getMenorStatus(reg)
      });
    });
    return statusFinal;
  },

  getMenorStatus(regComandaStatus) {
    let statusComanda = "";

    regComandaStatus.status.forEach((s) => {
      if (statusComanda.length > 0) {
        let posicaoNovoStatus = this.situacoes.indexOf(s);
        let posicaoStatusAnterior = this.situacoes.indexOf(statusComanda);
        if (posicaoNovoStatus < posicaoStatusAnterior) {
          statusComanda = s;
        }
      } else {
        statusComanda = s;
      }
    });

    return statusComanda;
  }
}

export default TotaisComanda;
